import { useEffect, useState } from "react";

type Props = {
  visitId: string;
  onEnd: () => void;
};

export function useTimeUpdates({ visitId, onEnd }: Props) {
  const [time, setTime] = useState<string>("");

  useEffect(() => {
    const eventSource = new EventSource(`/api/visits/${visitId}/timings`);

    eventSource.addEventListener("timingUpdate", (event) => {
      setTime(event.data);
    });

    eventSource.addEventListener("timingEnd", () => {
      return onEnd();
    });

    eventSource.onerror = (error) => {
      console.error("timing error", error);
    };

    return () => {
      eventSource.close();
    };
  }, [visitId, onEnd]);

  return time;
}
